import {ApiUrl} from "../../auth/authMethods";
import {useState} from "react";
import ContentContainer from "../../component/ContentContainer";
import PaginationControl from "../../component/Pagination/PaginationControl";
import PaymentList from "./Components/PaymentList";
import PopupAddPayment from "./Components/PopupAdd/PopupAddPayment";
import {useUser} from "../../auth/AuthProvider";
import DownloadParticipantReport from "./Components/DownloadParticipantReport";


export default function Payment(){

    const baseUrl = `${ApiUrl}/pagamentos`
    const [loadData, setLoadData] = useState(true)

    const { user } = useUser();

    const [size, setSize] = useState(10)
    const [page, setPage] = useState(0)
    const [sort, setSort] = useState("")

    const [totalPages, setTotalPages] = useState(0)
    const [totalElements, setTotalElements] = useState(0)

    return <ContentContainer width={'xl'}>
        <h1>Lista de Pagamentos </h1>
        { user?.isAdmin ?
            <PopupAddPayment baseUrl={baseUrl} setLoadData={setLoadData}/>:
            <DownloadParticipantReport/>
        }
        <PaymentList
            baseUrl={baseUrl + '/list'}
            loadData={loadData}
            setLoadData={setLoadData}
            page={page}
            setPage={setPage}
            size={size}
            setSize={setSize}
            totalPages={totalPages}
            setTotalPages={setTotalPages}
            totalElements={totalElements}
            setTotalElements={setTotalElements}
            sort={sort} setSort={setSort}
        />
        <PaginationControl
            totalElements={totalElements}
            page={page}
            setPage={setPage}
            size={size}
            setSize={setSize}
            setLoadData={setLoadData}
        />
    </ContentContainer>
}